import { useEffect } from 'react'
import { StyledVehicleDetailImage } from './VehicleDetailImage.style'
import { useDtmAnalytics } from 'hooks/useDtmAnalytics'
import { AnalyticsStore, DtmPageName } from 'utils/analyticsUtils'

interface IProps {
  lowRes: string[]
  thumbnail: string
  error: boolean
  vin: string
}

export const FyusionDetailImage = ({ thumbnail, lowRes, error, vin }: IProps) => {
  const { endComponentLoad, userInteraction } = useDtmAnalytics()

  const prismData = lowRes.map((lowResItem) => ({
    category: '',
    src: {
      thumbnail: lowResItem,
      lowRes: lowResItem
    },
    description: ''
  }))

  useEffect(() => {
    const viewerId = `fyuse_viewer_${vin}`

    const viewerElement = document.getElementById(viewerId)
    if (viewerElement) {
      viewerElement.innerHTML = ''
    }

    ;(window as any).SVFyusion.addViewer(prismData, viewerId)

    endComponentLoad('newimageviewer')

    // These tags use a hardcoded "vdp:" prefix matching the legacy VDP-only tag names,
    // so only fire them when this viewer is actually rendered on the VDP page — this
    // component is also reused for SRP/Current Bids/Watch List card thumbnails.
    const handleImageClick = () => {
      if (AnalyticsStore.pageName === DtmPageName.VDP) {
        userInteraction('vdp:image')
      }
    }
    const handleFullscreenChange = () => {
      if (AnalyticsStore.pageName !== DtmPageName.VDP) return
      if (document.fullscreenElement) {
        userInteraction('vdp:newimageviewerclick:fullscreenclick')
      } else {
        userInteraction('vdp:newimageviewerclick:fullscreenexit')
      }
    }

    viewerElement?.addEventListener('click', handleImageClick)
    document.addEventListener('fullscreenchange', handleFullscreenChange)

    return () => {
      if (viewerElement) {
        viewerElement.innerHTML = ''
      }
      viewerElement?.removeEventListener('click', handleImageClick)
      document.removeEventListener('fullscreenchange', handleFullscreenChange)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vin, thumbnail])

  return (
    <StyledVehicleDetailImage>
      {error ? (
        <img src={`content/img/AwaitingCarImage.png`} alt="Awaiting Car" />
      ) : (
        <div id={`fyuse_viewer_${vin}`}></div>
      )}
    </StyledVehicleDetailImage>
  )
}
